import { render, staticRenderFns } from "./EditMntCategory.vue?vue&type=template&id=187221ff"
import script from "./EditMntCategory.vue?vue&type=script&lang=js"
export * from "./EditMntCategory.vue?vue&type=script&lang=js"
import style0 from "./EditMntCategory.vue?vue&type=style&index=0&id=187221ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports